/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ temperature: NonNullable<unknown> }} Free_Cooling_TextInputs */

const fr_free_cooling_text = /** @type {((inputs: Free_Cooling_TextInputs) => LocalizedString) & { parts: (inputs: Free_Cooling_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Free_Cooling_TextInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Le mode free cooling s’enclenche automatiquement dès que la température extérieure est inférieure d’au moins ${i?.temperature}°C (Consigne delta température) à la température intérieure`)
		}),
		{
			parts: /** @type {(inputs: Free_Cooling_TextInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Le mode free cooling s’enclenche automatiquement dès que la température extérieure est inférieure d’au moins " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.temperature) }, { type: "text", value: "°C (Consigne delta température)" }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: " à la température intérieure" }])
			})
		}
	)
);

const en_free_cooling_text = /** @type {((inputs: Free_Cooling_TextInputs) => LocalizedString) & { parts: (inputs: Free_Cooling_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Free_Cooling_TextInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Free cooling mode starts automatically when the external temperature is at least ${i?.temperature}°C (Temperature delta setpoint) lower than the internal temperature`)
		}),
		{
			parts: /** @type {(inputs: Free_Cooling_TextInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Free cooling mode starts automatically when the external temperature is at least " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.temperature) }, { type: "text", value: "°C (Temperature delta setpoint)" }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: " lower than the internal temperature" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Free cooling mode starts automatically when the external temperature is at least {temperature}°C (Temperature delta setpoint) lower than the internal tempera..." |
*
* @param {Free_Cooling_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const free_cooling_text = /** @type {((inputs: Free_Cooling_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Free_Cooling_TextInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Free_Cooling_TextInputs, { locale?: "fr" | "en" }, { span: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Free_Cooling_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_free_cooling_text(inputs)
			return fr_free_cooling_text(inputs)
		}),
		{
			parts: /** @type {(inputs: Free_Cooling_TextInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Free_Cooling_TextInputs) => import('../runtime.js').MessagePart[] }} */ (en_free_cooling_text).parts?.(inputs) ?? [{ type: "text", value: en_free_cooling_text(inputs) }]
				return /** @type {{ parts?: (inputs: Free_Cooling_TextInputs) => import('../runtime.js').MessagePart[] }} */ (fr_free_cooling_text).parts?.(inputs) ?? [{ type: "text", value: fr_free_cooling_text(inputs) }]
			})
		}
	)
);